import React from 'react';
import ReactDOM from 'react-dom/client';
import Rutas from './route/Rutas';
import i18n from './i18n'
import { iniciarAnalytics } from './analytics';
import { idiomaDeUrl } from './rutas';

// El idioma inicial sale de la URL (/en/... = inglés), antes del primer render.
i18n.changeLanguage(idiomaDeUrl(window.location.pathname));

iniciarAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Rutas />
  </React.StrictMode>
);


// reportWebVitals();
